// src/components/ActionClass.jsx
import React, { useRef, useState, useEffect } from 'react';
import PageLayout from '../components/PageLayout';
import styles from '../styles/ActionClass.module.css';

const ActionClass = () => {
 const [message, setMessage] = useState('');
 const dragRef = useRef(null);
 const dropRef = useRef(null);

 useEffect(() => {
  const source = dragRef.current;
  const target = dropRef.current;

  const handleDragStart = (e) => {
   e.dataTransfer.setData('text/plain', source.value);
  };

  const handleDragOver = (e) => {
   e.preventDefault();
  };

  const handleDrop = (e) => {
   e.preventDefault();
   const text = e.dataTransfer.getData('text/plain');
   target.value = text;
  };

  source.addEventListener('dragstart', handleDragStart);
  target.addEventListener('dragover', handleDragOver);
  target.addEventListener('drop', handleDrop);

  return () => {
   source.removeEventListener('dragstart', handleDragStart);
   target.removeEventListener('dragover', handleDragOver);
   target.removeEventListener('drop', handleDrop);
  };
 }, []);

 const handleDoubleClick = () => {
  setMessage('Clicked Me Twice');
 };

 return (
  <PageLayout
   title="🎯 ACTION CLASS & DRAG-DROP"
   sidebarContent={
    <ul>
     <li>🖱️ Right Click, Double Click</li>
     <li>🎯 Action Class Dropdown Options</li>
     <li>📦 Drag & Drop with Animated UI</li>
    </ul>
   }
  >
   <div className={styles.row}>
    {/* ACTION CLASS SECTION */}
    <div className={styles.col}>
     <h3 className={styles.heading}>ACTION CLASS</h3>

     <div className={styles.actionRow}>
      {/* Right Click */}
      <div className={styles.navBox}>
       <a
        id="bst_anchor"
        name="right_click"
        className={styles.link}
        href="https://www.bsparksoftwaretechnologies.com/playwright-training-in-chennai"
        target="_blank"
        rel="noreferrer"
       >
        Right Click
       </a>
      </div>

      {/* Dropdown */}
      <div className={styles.dropdownWrapper}>
       <div className={styles.dropdownButton}>ACTION CLASS OPTIONS</div>
       <ul className={styles.dropdownList} id="dropdown" name="bst_drop">
        <li><a id="bst_alert" name="bst_alert" href="alert" className={styles.dropdownLink}>Alert</a></li>
        <li><a id="bst_frames" name="bst_frames" href="frames" className={styles.dropdownLink}>Frames</a></li>
        <li><a id="bst_ss" name="bst_ss" href="screenshot" className={styles.dropdownLink}>Screenshot</a></li>
       </ul>
      </div>
     </div>

     <button id="bst_btn" className={styles.doubleClickBtn} onDoubleClick={handleDoubleClick}>
      Double Click Me
     </button>
     <p id="bst_para" className={styles.message}>{message}</p>
    </div>

    {/* DRAG & DROP SECTION */}
    <div className={styles.col}>
     <h3 className={styles.heading}>DRAG AND DROP</h3>

     {/* The draggable textarea */}
     <textarea
      ref={dragRef}
      className={styles.draggableBox}
      draggable
      title="Drag this"
      id="bst_drag" // Added a new ID for testing
      defaultValue="Bspark Software Technologies"
     />

     <p className={styles.instruction} id="bst">
      Drag the text above and drop into the box below
     </p>

     {/* The drop target textarea */}
     <textarea
      ref={dropRef}
      className={styles.dropArea}
      placeholder="Drop Here..."
      id="bst_txtarea"
     />
    </div>
   </div>
  </PageLayout>
 );
};

export default ActionClass;